module.exports = "<input class=\"js-time-input input input_time\">";


//////////////////
// WEBPACK FOOTER
// ../src/form/editors/impl/dateTime/templates/timeInput.hbs
// module id = 660
// module chunks = 0